// deps
import React, { memo, ReactElement } from "react";

// internal deps
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { Loader } from "@swiggy-private/dls-web-core/dist/components/Loader";
import { useEffectOnce } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

// test-ids
import { GROUP_CART_ORDER_DATA_TEST_IDS } from "@swiggy-private/cart-test-ids";

// style
import { HostContainer, GuestContainer, TextContainer } from "./CartGroupOrderFooter.style";

// constants
import {
    CONTINUE_TO_CHECKOUT,
    GUEST_BOTTOM_FOOTER_SRC,
    GUEST_FOOTER_SUBTITLE,
    GUEST_FOOTER_TITLE,
    GUESTS_CANT_EDIT,
} from "@cart-ui/constants/GroupCart";

// components
import { default as ArrowIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/arrowFront/16";

const FooterLoader = (): ReactElement => {
    return <Loader size="small" type="primary" backgroundColor="text_inverse_Low_Emphasis" isDisabled={false} />;
};

const GUEST_FOOTER_IMAGE_DIMS = {
    height: "117px",
    width: "89px",
};

const CartGroupOrderFooter = ({
    isHost,
    impressionEvent,
    onClick,
    checkoutInProgress,
}: {
    isHost: boolean;
    impressionEvent?: () => void;
    onClick: VoidFunction;
    checkoutInProgress?: boolean;
}) => {
    useEffectOnce(() => {
        impressionEvent?.();
    });

    if (isHost) {
        return (
            <HostContainer data-testid={GROUP_CART_ORDER_DATA_TEST_IDS.FOOTER}>
                <FullWidthButton
                    variant="positive"
                    subLabel={GUESTS_CANT_EDIT}
                    onClick={onClick}
                    outlinedIcon={checkoutInProgress ? FooterLoader : ArrowIcon}
                >
                    {CONTINUE_TO_CHECKOUT}
                </FullWidthButton>
            </HostContainer>
        );
    }
    return (
        <GuestContainer data-testid={GROUP_CART_ORDER_DATA_TEST_IDS.FOOTER}>
            <Image cloudinaryId={GUEST_BOTTOM_FOOTER_SRC} {...GUEST_FOOTER_IMAGE_DIMS} />
            <TextContainer>
                <Text variant="V2.subheading1.neutral.black" color="text_Med_Emphasis">
                    {GUEST_FOOTER_TITLE}
                </Text>
                <Text variant="V2.subheading1.neutral.medium" color="text_Med_Emphasis">
                    {GUEST_FOOTER_SUBTITLE}
                </Text>
            </TextContainer>
        </GuestContainer>
    );
};

export default memo(CartGroupOrderFooter);
